import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    id = '',
    name = '',
    level = 1,
    desc = '',
    users = [],
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.kpi.auditFLow.save, {
        id,
        name,
        level,
        desc,
        users,
    }, options);
    if (error) return { error, status };
    return content || { id: '' };
};
